<template>
  <div class="animate-pulse bg-grey-divider-subdued" :class="[roundedClass, customClass]" aria-hidden="true" />
</template>

<script lang="ts">
export default {
  name: 'Skeleton',
  props: {
    customClass: {
      type: String,
      default: '',
    },
    rounded: {
      type: [Boolean, String],
      default: true,
      validator: (v: boolean | string) => v === true || v === false || v === 'full',
    },
  },
  computed: {
    roundedClass(): string {
      if (this.rounded === 'full') return 'rounded-full';
      if (this.rounded === true) return 'rounded';
      return '';
    },
  },
};
</script>
